
let dateMessage = "";
let timeMessage = "";
let datetimeMessage = "";
let requiredMessage = "";

export function getConfiguration(): ValidatorConfig {
    return {
        rules: {
            date: function (input: JQuery<HTMLInputElement>): boolean {
                if (input.is("[data-role=datepicker]")) {
                    return kendo.parseDate(input.val()) !== null;
                }
                return true;
            },
            time: function (input: JQuery<HTMLInputElement>): boolean {
                if (input.is("[data-role=timepicker]")) {
                    return kendo.parseDate(input.val(), "HH:mm") !== null;
                }
                return true;
            },
            datetime: function (input: JQuery<HTMLInputElement>): boolean {
                if (input.is("[data-role=datetimepicker]")) {
                    return kendo.parseDate(input.val()) !== null;
                }
                return true;
            },
            required: function (input: JQuery<HTMLInputElement>): boolean {
                return input.val() !== null && input.val() !== '';
            }
        },
        messages: {
            required: requiredMessage,
            date: dateMessage,
            time: timeMessage,
            datetime: datetimeMessage
        }
    };
}

export function initialize(localizedRequiredMessage: string, localizedDateMessage: string, localizedTimeMessage: string, localizedDateTimeMessage: string): void {
    requiredMessage = localizedRequiredMessage;
    dateMessage = localizedDateMessage;
    timeMessage = localizedTimeMessage;
    datetimeMessage = localizedDateTimeMessage;
}



